"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Step = exports.Stepper = exports.StepperDefaultProps = exports.StepDefaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Step = function Step(props) {
  var className = props.className,
      children = props.children,
      disabled = props.disabled,
      onClick = props.onClick,
      stepNumber = props.stepNumber,
      currentlyActive = props.currentlyActive,
      currentlyCompleted = props.currentlyCompleted,
      NewProps = _objectWithoutProperties(props, ["className", "children", "disabled", "onClick", "stepNumber", "currentlyActive", "currentlyCompleted"]);

  var elementClassNames = (0, _classnames.default)('stepper-element', className, {
    'stepper-element__completed': currentlyCompleted,
    'stepper-element__active': currentlyActive,
    'stepper-element__clickable': typeof onClick !== 'undefined' && !disabled,
    'stepper-element__disabled': disabled
  });
  var stepClassNames = (0, _classnames.default)({
    'stepper--step': true
  });
  var iconClassNames = (0, _classnames.default)({
    'stepper-element-icon': true
  });

  var _onClick = function _onClick(event) {
    if (!disabled && onClick) {
      onClick(event);
    }
  }; // ADA compliant - allow an enter key to act like a click.


  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    key: stepNumber,
    className: elementClassNames,
    onClick: _onClick,
    role: "button",
    tabIndex: 0,
    onKeyDown: _handleKeyPress
  }, NewProps), /*#__PURE__*/_react.default.createElement("div", {
    className: iconClassNames
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: stepClassNames
  }, children));
};

exports.Step = Step;
Step.propTypes = {
  className: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  stepNumber: _propTypes.default.number.isRequired,
  currentlyActive: _propTypes.default.bool.isRequired,
  currentlyCompleted: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func,
  children: _propTypes.default.string
};
var StepDefaultProps = {
  className: '',
  disabled: false,
  stepNumber: 1,
  currentlyActive: false,
  currentlyCompleted: false
};
exports.StepDefaultProps = StepDefaultProps;
Step.defaultProps = StepDefaultProps;

var Stepper = function Stepper(props) {
  var children = props.children,
      className = props.className,
      disabled = props.disabled,
      activeStep = props.activeStep,
      onClick = props.onClick,
      disableFutureSteps = props.disableFutureSteps,
      NewProps = _objectWithoutProperties(props, ["children", "className", "disabled", "activeStep", "onClick", "disableFutureSteps"]); // Which step is the currently active step? Make sure it's valid.


  var currentlyActiveStep = typeof activeStep === 'undefined' || activeStep < 1 || activeStep > _react.default.Children.count(children) ? 1 : activeStep; // Any special classes to add to the stepper?

  var stepperClassNames = (0, _classnames.default)('stepper-stepper', className, {
    'stepper-stepper__disabled': disabled
  });
  var trackClassNames = (0, _classnames.default)({
    'stepper-track': true,
    'stepper-track__disabled': disabled
  }); // Combine the properties passed to the parent with the child elements.
  // Processing react children is a little weird, see https://reactjs.org/docs/react-api.html#reactchildren for details.

  var lastStepNumber = 0;

  var stepElements = _react.default.Children.map(children, function (child) {
    if (child.type === Step) {
      lastStepNumber += 1;
      var stepActive = lastStepNumber === currentlyActiveStep;
      var stepCompleted = lastStepNumber < currentlyActiveStep;
      var stepDisabled = disabled || child.props.disabled || disableFutureSteps && lastStepNumber > currentlyActiveStep;
      var stepOnClick = typeof child.props.onClick !== 'undefined' ? child.props.onClick : onClick;

      var newChild = _react.default.cloneElement(child, {
        onClick: stepOnClick,
        disabled: stepDisabled,
        stepNumber: lastStepNumber,
        currentlyActive: stepActive,
        currentlyCompleted: stepCompleted
      });

      return newChild;
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }); // No valid steps then display nothing.


  if (lastStepNumber === 0) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  } // Aligning the track and the step icons and labels:
  // divide the whole length by the number of elements we're outputting to get a percent of track per step.


  var percentWidthPerStep = 100 / lastStepNumber; // divide one section by 2 so we get width for each end individually.

  var percentEndWidth = percentWidthPerStep / 2; // Active bar length is the currently active step * width per step, then add an end spacer too.

  var percentActiveTrackBarWidth = (currentlyActiveStep - 1) * percentWidthPerStep + percentEndWidth; // Inactive bar length is what is left from 100%.

  var percentInactiveTrackBarWidth = 100 - percentActiveTrackBarWidth;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: stepperClassNames
  }, NewProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "stepper-elements"
  }, stepElements), /*#__PURE__*/_react.default.createElement("div", {
    className: trackClassNames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "stepper-trackbar stepper-track__active",
    style: {
      width: "".concat(percentActiveTrackBarWidth, "%"),
      flexBasis: "".concat(percentActiveTrackBarWidth, "%")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "stepper-trackbar stepper-track__inactive",
    style: {
      width: "".concat(percentInactiveTrackBarWidth, "%"),
      flexBasis: "".concat(percentInactiveTrackBarWidth, "%")
    }
  })));
};

exports.Stepper = Stepper;
Stepper.propTypes = {
  activeStep: _propTypes.default.number.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  className: _propTypes.default.any.isRequired,
  disableFutureSteps: _propTypes.default.bool.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.any, _propTypes.default.arrayOf(_propTypes.default.any)]),
  onClick: _propTypes.default.func
};
var StepperDefaultProps = {
  className: '',
  disabled: false,
  activeStep: 1,
  // 1 based
  disableFutureSteps: true
};
exports.StepperDefaultProps = StepperDefaultProps;
Stepper.defaultProps = StepperDefaultProps;
var _default = Stepper;
exports.default = _default;